import { render, staticRenderFns } from "./AddApiKey.vue?vue&type=template&id=06d356a8&"
import script from "./AddApiKey.vue?vue&type=script&lang=js&"
export * from "./AddApiKey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports